import { useEffect } from "react";
import { useLocation } from "react-router";

// Wrapper component used to scroll to top on route change.
const ScrollReset = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>
};

export default ScrollReset;